import React, { useEffect, useMemo, useState, useRef } from "react"
import { UncontrolledTooltip } from "reactstrap"
import TableContainer from "../../components/Common/TableContainer"
import Spinners from "components/Common/Spinner"
import { Link } from "react-router-dom"
import { useDispatch } from "react-redux"

// #region selectors
import {
  useCajaId_Relacion_Cuenta_Cargo,
  useCajaError,
  useCajaIsLoading,
  useCampusVirtualIdCampus,
  useCampusVirtualAuthenticatedUser,
  useCajaoAlumno,
  useAuthIsAuthenticated,
  useAuthIdPersonaAuthenticated,
  useCajaRowsAffectedDeloCargo,
} from "../../store/selectors"
// #endregion

// #region actions
import {
  postCajaAddCargo as onPostCajaAddCargo,
  getCajaEstadoCuenta as onGetEstadoCuenta,
  delCajaDeloCargoSuccess as onSetRowsAffectedDeloCargo,
  postCajaAddCargoSuccess,
} from "../../store/actions"
// #endregion

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const CargosListado = ({ dataServicios }) => {
  //
  const dispatch = useDispatch()

  const id_Relacion_Cuenta_Cargo = useCajaId_Relacion_Cuenta_Cargo()
  const error = useCajaError()
  const isLoading = useCajaIsLoading()
  const idCampus = useCampusVirtualIdCampus()
  const oAlumno = useCajaoAlumno()
  const isAuthenticated = useAuthIsAuthenticated()
  const rowsAffectedDeleteoCargo = useCajaRowsAffectedDeloCargo()

  useEffect(() => {
    if (id_Relacion_Cuenta_Cargo > 0) {
      toast.success("Cargo Agregado", {
        autoClose: 2000,
      })
      dispatch(
        onGetEstadoCuenta({
          nombreSolicitud: "getestadocuentaxidalumno",
          idAlumno: oAlumno.id_Alumno,
        })
      )
      dispatch(postCajaAddCargoSuccess(0))
    }
  }, [id_Relacion_Cuenta_Cargo])

  useEffect(() => {
    if (rowsAffectedDeleteoCargo > 0) {
      toast.success("Cargo Eliminado", {
        autoClose: 2000,
      })
      dispatch(
        onGetEstadoCuenta({
          nombreSolicitud: "getestadocuentaxidalumno",
          idAlumno: oAlumno.id_Alumno,
        })
      )
      dispatch(onSetRowsAffectedDeloCargo(0))
    }
  }, [rowsAffectedDeleteoCargo])

  useEffect(() => {
    if (error && error.length) {
      console.log("useEffect::linea 382:error:", error)
      toast.error(error, {
        autoClose: 2000,
      })
    }
  }, [error])

  const handlerAddCargo = oServicio => {
    console.log("Click", oServicio)
    if (isAuthenticated) {
      dispatch(
        onPostCajaAddCargo({
          nombreSolicitud: "postagregarcargo",
          idAlumno: oAlumno.id_Alumno,
          idCampus: idCampus,
          idServicio: oServicio.id_Servicio,
          Cantidad: oServicio.Cantidad,
          Dias_Extras: 9,
          Descripcion: oServicio.Descripcion,
        })
      )
    }
  }

  const columns = useMemo(
    () => [
      {
        header: "Concepto",
        accessorKey: "Nombre_Servicio",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Cantidad",
        accessorKey: "Cantidad",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Acción",
        enableColumnFilter: false,
        enableSorting: true,
        size: 50,
        cell: cellProps => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link
                  to="#"
                  onClick={() => handlerAddCargo(cellProps.row.original)}
                  className="btn btn-sm btn-soft-primary"
                  id={`viewtooltip-${cellProps.row.original.id_Servicio}`}
                >
                  <i className="mdi mdi-plus" />
                </Link>
              </li>
              <UncontrolledTooltip
                placement="top"
                target={`viewtooltip-${cellProps.row.original.id_Servicio}`}
              >
                Cargar
              </UncontrolledTooltip>
            </ul>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <ToastContainer />
      <TableContainer
        columns={columns}
        data={dataServicios || []}
        //isCustomPageSize={false}
        //CustomPageSize={dataServicios.length}
        isGlobalFilter={true}
        // divClassName="container"
        // isAddButton={true}
        // buttonClass="btn btn-success"
        //buttonClass="btn btn-primary btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
        // buttonName=" Añadir "
        //handleUserClick={handleStatusFilterSelection}
        //isJobListGlobalFilter={true}
        //statusOptions={statusOptions}
        isLoading={isLoading}
        isPagination={true}
        SearchPlaceholder="Búsqueda ..."
        tableClass="table-condensed align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline border-top"
        theadClass="table-light"
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
        //selectedValue={sListaIdStatus}
      />
    </React.Fragment>
  )
}

export default CargosListado
